import apiRequest from './apiRequest';

export default async function getUserApiKey(serviceID?: string) {
  const qs = serviceID
    ? `?serviceID=${encodeURIComponent(serviceID)}`
    : '';
  return apiRequest<{ apiKey: string; serviceID: string }>(
    'user',
    `/users/apiKey${qs}`,
  );
}
